<template>
  <div>
    <a
      href="#"
      class="btn btn-primary float-right half-gutter-bottom"
      v-on:click.prevent="openModal"
      >Add User</a
    >
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email Address</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="key" v-for="(user, key) in users">
          <td>{{ user.first_name }} {{ user.last_name }}</td>
          <td>{{ user.email }}</td>
          <td>
            <button
              class="btn btn-warning"
              v-on:click.prevent="openEditModal(key)"
            >
              Edit
            </button>
            <button class="btn btn-danger" v-on:click.prevent="removeUser(key)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal :show="modals.form" :large="true" v-on:close="closeModal">
      <div slot="title">
        <h4 v-text="formModalTitle"></h4>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="form-horizontal">
            <inputbox
              name="first_name"
              label="First Name"
              :required="true"
              v-model="form.first_name"
              :show-error="form.errors.has('first_name')"
              :error-message="form.errors.get('first_name')"
            ></inputbox>

            <inputbox
              name="last_name"
              label="Last Name"
              :required="true"
              v-model="form.last_name"
              :show-error="form.errors.has('last_name')"
              :error-message="form.errors.get('last_name')"
            ></inputbox>

            <inputbox
              name="email"
              label="Email Address"
              type="email"
              :required="true"
              v-model="form.email"
              :show-error="form.errors.has('email')"
              :error-message="form.errors.get('email')"
            ></inputbox>

            <inputbox
              name="password"
              label="Password"
              type="password"
              :required="true"
              v-model="form.password"
              :show-error="form.errors.has('password')"
              v-if="editingIndex === null"
              :error-message="form.errors.get('password')"
            ></inputbox>

            <selectlist
              name="role"
              label="Role"
              v-model="form.role"
              placeholder="Please Select"
              :options="roles"
            ></selectlist>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="closeModal"
        >
          Close
        </button>
        <button class="btn btn-primary" v-on:click.prevent="saveForm">
          Save User
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      modals: {
        form: false
      },
      form: new window.Form({
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        role: ''
      }),
      editingIndex: null
    };
  },

  mounted() {
    this.getAllUsers();
  },

  computed: {
    formModalTitle() {
      if (this.editingIndex !== null) {
        return 'Edit User';
      }

      return 'Add User';
    },

    roles() {
      return this.$store.getters['Roles/all'];
    }
  },

  methods: {
    removeUser(key) {
      window
        .swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete the user!'
        })
        .then(() => {
          let user = this.users[key];

          window.Ajax.delete(
            `/credit-hire-organisations/${this.$route.params.identifier}/users/${user.identifier}`
          )
            .then(response => {
              window.swal(
                'Deleted!',
                'The user was deleted successfully!',
                'success'
              );
              this.users.splice(key, 1);
            })
            .catch(err => {
              window.toastify.error(
                'Error',
                'Sorry, there was an issue deleting the user.'
              );
            })
            .catch(() => {});
        });
    },

    getAllUsers() {
      window.Ajax.get(
        `/credit-hire-organisations/${this.$route.params.identifier}/users`
      )
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {});
    },

    saveForm() {
      let method = 'post';
      let url = `/credit-hire-organisations/${this.$route.params.identifier}/users`;

      if (this.editingIndex !== null) {
        method = 'put';
        url = `/credit-hire-organisations/${
          this.$route.params.identifier
        }/users/${this.users[this.editingIndex].identifier}`;
      }

      this.form[method](url)
        .then(response => {
          if (this.editingIndex !== null) {
            this.users[this.editingIndex] = response;
            this.closeModal();
            return;
          }

          this.users.push(response);
          this.closeModal();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an issue saving the user'
          );
        });
    },

    openModal() {
      this.modals.form = true;
    },

    closeModal() {
      this.modals.form = false;
      this.form.reset();
    },

    openEditModal(key) {
      this.editingIndex = key;

      this.form.first_name = this.users[key].first_name;
      this.form.last_name = this.users[key].last_name;
      this.form.email = this.users[key].email;
      this.form.role = this.users[key].role_id;
      this.modals.form = true;
    }
  }
};
</script>
